/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import * as Types from '../../graphql.generated'

const defaultOptions = {} as const
export type CreatePatientFileMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  input: Types.CreatePatientFileInput
}>

export type CreatePatientFileMutation = {
  __typename?: 'Mutation'
  createPatientFile: {
    __typename?: 'CreatePatientFile'
    uploadURL: string
    method: string
    file: {
      __typename?: 'PatientFile'
      fileID: string
      filename: string
      size: number
      contentType: string
      objectKey: string
      uploadedAt?: Date | null
    }
  }
}

export type PatientFileDownloadUrlQueryVariables = Types.Exact<{
  fileID: Types.Scalars['ID']['input']
}>

export type PatientFileDownloadUrlQuery = {
  __typename?: 'Query'
  patientFile: {
    __typename?: 'PatientFile'
    downloadURL?: string | null
    fileID: string
    filename: string
    size: number
    contentType: string
    objectKey: string
    uploadedAt?: Date | null
  }
}

export type UpdatePatientFileMutationVariables = Types.Exact<{
  fileID: Types.Scalars['ID']['input']
  input: Types.UpdatePatientFileInput
}>

export type UpdatePatientFileMutation = {
  __typename?: 'Mutation'
  updatePatientFile: {
    __typename?: 'PatientFile'
    fileID: string
    filename: string
    size: number
    contentType: string
    objectKey: string
    uploadedAt?: Date | null
  }
}

export type PatientFileFragment = {
  __typename?: 'PatientFile'
  fileID: string
  filename: string
  size: number
  contentType: string
  objectKey: string
  uploadedAt?: Date | null
}

export const PatientFileFragmentDoc = gql`
  fragment PatientFile on PatientFile {
    fileID
    filename
    size
    contentType
    objectKey
    uploadedAt
  }
`
export const CreatePatientFileDocument = gql`
  mutation createPatientFile($uid: ID!, $input: CreatePatientFileInput!) {
    createPatientFile(uid: $uid, input: $input) {
      uploadURL
      method
      file {
        ...PatientFile
      }
    }
  }
  ${PatientFileFragmentDoc}
`
export type CreatePatientFileMutationFn = Apollo.MutationFunction<
  CreatePatientFileMutation,
  CreatePatientFileMutationVariables
>

/**
 * __useCreatePatientFileMutation__
 *
 * To run a mutation, you first call `useCreatePatientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientFileMutation, { data, loading, error }] = useCreatePatientFileMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientFileMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePatientFileMutation, CreatePatientFileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreatePatientFileMutation, CreatePatientFileMutationVariables>(
    CreatePatientFileDocument,
    options
  )
}
export type CreatePatientFileMutationHookResult = ReturnType<typeof useCreatePatientFileMutation>
export type CreatePatientFileMutationResult = Apollo.MutationResult<CreatePatientFileMutation>
export type CreatePatientFileMutationOptions = Apollo.BaseMutationOptions<
  CreatePatientFileMutation,
  CreatePatientFileMutationVariables
>
export const PatientFileDownloadUrlDocument = gql`
  query patientFileDownloadURL($fileID: ID!) {
    patientFile(fileID: $fileID) {
      ...PatientFile
      downloadURL
    }
  }
  ${PatientFileFragmentDoc}
`

/**
 * __usePatientFileDownloadUrlQuery__
 *
 * To run a query within a React component, call `usePatientFileDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientFileDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientFileDownloadUrlQuery({
 *   variables: {
 *      fileID: // value for 'fileID'
 *   },
 * });
 */
export function usePatientFileDownloadUrlQuery(
  baseOptions: Apollo.QueryHookOptions<PatientFileDownloadUrlQuery, PatientFileDownloadUrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<PatientFileDownloadUrlQuery, PatientFileDownloadUrlQueryVariables>(
    PatientFileDownloadUrlDocument,
    options
  )
}
export function usePatientFileDownloadUrlLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PatientFileDownloadUrlQuery, PatientFileDownloadUrlQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<PatientFileDownloadUrlQuery, PatientFileDownloadUrlQueryVariables>(
    PatientFileDownloadUrlDocument,
    options
  )
}
export type PatientFileDownloadUrlQueryHookResult = ReturnType<typeof usePatientFileDownloadUrlQuery>
export type PatientFileDownloadUrlLazyQueryHookResult = ReturnType<typeof usePatientFileDownloadUrlLazyQuery>
export type PatientFileDownloadUrlQueryResult = Apollo.QueryResult<
  PatientFileDownloadUrlQuery,
  PatientFileDownloadUrlQueryVariables
>
export const UpdatePatientFileDocument = gql`
  mutation updatePatientFile($fileID: ID!, $input: UpdatePatientFileInput!) {
    updatePatientFile(fileID: $fileID, input: $input) {
      ...PatientFile
    }
  }
  ${PatientFileFragmentDoc}
`
export type UpdatePatientFileMutationFn = Apollo.MutationFunction<
  UpdatePatientFileMutation,
  UpdatePatientFileMutationVariables
>

/**
 * __useUpdatePatientFileMutation__
 *
 * To run a mutation, you first call `useUpdatePatientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientFileMutation, { data, loading, error }] = useUpdatePatientFileMutation({
 *   variables: {
 *      fileID: // value for 'fileID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientFileMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePatientFileMutation, UpdatePatientFileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdatePatientFileMutation, UpdatePatientFileMutationVariables>(
    UpdatePatientFileDocument,
    options
  )
}
export type UpdatePatientFileMutationHookResult = ReturnType<typeof useUpdatePatientFileMutation>
export type UpdatePatientFileMutationResult = Apollo.MutationResult<UpdatePatientFileMutation>
export type UpdatePatientFileMutationOptions = Apollo.BaseMutationOptions<
  UpdatePatientFileMutation,
  UpdatePatientFileMutationVariables
>
